<template>
  <div id="coaching">
    <v-fab-transition>
      <v-btn
        color="primary"
        fab
        large
        dark
        class="v-btn--open-dialog"
        @click="parametersDialog = !parametersDialog"
        style="z-index: 100"
      >
        <v-icon v-if="!parametersDialog">keyboard_arrow_right</v-icon>
        <v-icon v-if="parametersDialog">mdi-close</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog v-model="parametersDialog" max-width="600px">
      <v-card class="mx-auto" max-width="1000">
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-domain"
                  v-model="companies"
                  :items="uniqueCompanies"
                  label="Companies"
                  @change="getCoaching"
                ></v-select>
              </v-col>
            </v-row>
             <v-row>
              <v-col cols="12">
                <v-select
                  prepend-icon="search"
                  v-model="coachingNames"
                  :items="uniqueCoachingNames"
                  label="Course names"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="isAdminRole">
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-account-multiple"
                  v-model="participants"
                  :items="uniqueParticipants"
                  label="Participants"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-menu
                  v-model="from"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fromDate"
                      label="From"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    @input="from = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  v-model="to"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="toDate"
                      label="To"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    @input="to = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-btn
                @click="parametersDialog = !parametersDialog"
                color="red"
                dark
                >Close</v-btn
              >
              <div class="flex-grow-1"></div>
              <v-btn @click="initialise()" color="info">Update</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container style="width: 100%; max-width: 1060px">
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <p class="text-center display-1 primary--text">Coaching feedback</p>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Companies</v-toolbar-title
              ><a
                class="reset"
                @click="resetFilters()"
                style="display: true; margin-left: 5px"
                >reset all</a
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center">
              <div id="company-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Trainer</v-toolbar-title
              ><a
                class="reset"
                @click="resetFilters()"
                style="display: true; margin-left: 5px"
                >reset all</a
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center">
              <div id="coach-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Rate</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="rate-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Benefitted</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="benefitted-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Connected</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="connected-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Actions</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="actions-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Expectations</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="expectations-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Recommend</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="recommend-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Coaching Session</v-toolbar-title
              ><a
                class="reset"
                @click="resetFilters()"
                style="display: true; margin-left: 5px"
                >reset all</a
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center">
              <div id="coaching-session-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Feedback</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center" style="margin: 0 15px">
              <table
                id="feedback-table"
                class="table table-hover dc-data-table"
              >
                <thead>
                  <tr class="header">
                    <th>Feedback</th>
                    <th>Improvements</th>
                    <th style="width: 200px">Trainer</th>
                  </tr>
                </thead>
              </table>
            </v-row>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import { SurveyCoaching } from "../classes/SurveyCoaching";
import moment from "moment";
export default {
  data: () => ({
    graphData: {},
    loading: false,
    companyChart: null,
    rateChart: null,
    benefittedChart: null,
    connectedChart: null,
    actionsChart: null,
    coachingChart: null,
    coachingSessionChart: null,
    feedbackChart: null,
    techniquesTable: null,
    pieLabel: {},
    pieColor: {},
    parametersDialog: false,
    uniqueCompanies: [],
    uniqueParticipants: [],
    uniqueCoachingNames: [],
    from: false,
    fromDate: null,
    to: false,
    toDate: null,
    participants: "All",
    service: "All",
    companies: "All",
    coachingNames: "All",
  }),
  async mounted() {
    this.loading = true;
    const surveyCoaching = new SurveyCoaching();
    await surveyCoaching.getGraphData();
    this.uniqueCompanies = await surveyCoaching.getUniqueCompanyNames();
    this.uniqueCompanies.unshift("All");
    this.uniqueParticipants = await surveyCoaching.getUniqueCoach();
    this.uniqueParticipants.unshift("All");
    // this.uniqueCoachingNames = await surveyCoaching.getUniqueCoachingNames();
    this.uniqueCoachingNames.unshift("All");
    this.pieLabel = {
      0: "F",
      1: "M",
      average: "Avg",
      excellent: "Excel",
      good: "Good",
      poor: "Poor",
      verygood: "V.Good",
      yes: "Yes",
      no: "No",
      dontknow: "Dont Know",
      unsure: "Unsure",
      likely: "Likely",
      extremelylikely: "V.Likely",
      agree: "Agree",
      stronglyagree: "S.Agree",
      null: "Ignore",
    };
    this.pieColor = {
      excellent: "#B2D732",
      verygood: "#66B032",
      good: "#375F1B",
      average: "#e6550d",
      unsure: "#e6550d",
      poor: "#c62828",
      no: "#c62828",
      yes: "#B2D732",
      dontknow: "#e6550d",
      likely: "#66B032",
      extremelylikely: "#B2D732",
      agree: "#66B032",
      stronglyagree: "#B2D732",
      null: "#e376c2",
    };
    await this.initialise();
  },
  methods: {
    async initialise() {
      this.parametersDialog = false;
      this.loading = true;
      let query = [];
      let filter = null;

      if (this.companies && this.companies !== "All") {
        query.push({ company: { contains: this.companies } });
      }

      if (this.participants && this.participants !== "All") {
        query.push({ participants: { contains: this.participants } });
      }

      if (this.coachingNames && this.coachingNames !== "All") {
        query.push({ name: { contains: this.coachingNames } });
      }

      if (this.fromDate && this.toDate) {
        const from = moment(this.fromDate).toISOString();
        const to = moment(this.toDate).toISOString();
        query.push({
          date: {
            between: [from, to],
          },
        });
      }

      if (!this.isAdminRole) {
        Auth.currentAuthenticatedUser().then((user) => {
          filter = {};
          query.push({ participants: { contains: user.attributes.email } });

          query.forEach((q) => {
            Object.assign(filter, q);
          });
        });
      } else {
        if (query.length > 0) {
          filter = {};
          query.forEach((q) => {
            Object.assign(filter, q);
          });
        }
      }

      const surveyCoaching = new SurveyCoaching(filter);
      this.graphData = await surveyCoaching.getGraphData();
      this.drawCharts();
      this.loading = false;
    },
    drawCharts() {
      var cf = crossfilter(this.graphData);

      // Company Bar Chart
      this.renderCompanyChart(cf);

      // Rate Pie Chart
      this.renderRateChart(cf);

      // Benefitted Pie Chart
      this.renderBenefittedChart(cf);

      // Connected Pie Chart
      this.renderConnectedChart(cf);

      // Actions Chart
      this.renderActionsChart(cf);

      // Expections Chart
      this.renderExpectionsChart(cf);

      // Recommend Chart
      this.renderRecommendChart(cf);

      // Coach Table
      this.renderCoachChart(cf);

      // Coach Session Table
      this.renderCoachSessionChart(cf);

      // // Feedback Table
      this.renderFeedbackTable(cf);

      dc.renderAll();
    },
    renderCompanyChart(cf) {
      const that = this;
      this.companyChart = dc.barChart("#company-chart");
      var companyDimension = cf.dimension(function (d) {
        var ret = d.company === null ? "null" : d.company;
        return ret;
      });
      var companyGrouping = companyDimension.group();
      this.companyChart
        .width(1000)
        .height(380)
        .margins({ top: 0, right: 0, bottom: 120, left: 35 })
        .x(d3.scaleBand())
        .xUnits(dc.units.ordinal)
        .brushOn(false)
        //.xAxisLabel('')
        .yAxisLabel("No. Sessions")
        .dimension(companyDimension)
        .barPadding(0.1)
        .outerPadding(0.05)
        .group(companyGrouping)
        .on("postRender", function (c) {
          that.adjustBarChartLabels(c);
        });
    },
    renderCoachChart(cf) {
      const that = this;
      this.coachingChart = dc.barChart("#coach-chart");
      var coachingDimension = cf.dimension(function (d) {
        var ret = d.participants === null ? "null" : d.participants;
        return ret;
      });
      var coachingGrouping = coachingDimension.group();
      this.coachingChart
        .width(1000)
        .height(380)
        .margins({ top: 0, right: 0, bottom: 120, left: 35 })
        .x(d3.scaleBand())
        .xUnits(dc.units.ordinal)
        .brushOn(false)
        //.xAxisLabel('')
        .yAxisLabel("No. Sessions")
        .dimension(coachingDimension)
        .barPadding(0.1)
        .outerPadding(0.05)
        .group(coachingGrouping)
        .on("postRender", function (c) {
          that.adjustBarChartLabels(c);
        });
    },
    renderCoachSessionChart(cf) {
      const that = this;
      this.coachingSessionChart = dc.barChart("#coaching-session-chart");
      var coachingSessionDimension = cf.dimension(function (d) {
        var ret = d.description === null ? "null" : d.description;
        return ret;
      });
      var coachingSessionGrouping = coachingSessionDimension.group();
      this.coachingSessionChart
        .width(1000)
        .height(380)
        .margins({ top: 0, right: 0, bottom: 120, left: 35 })
        .x(d3.scaleBand())
        .xUnits(dc.units.ordinal)
        .brushOn(false)
        //.xAxisLabel('')
        .yAxisLabel("No. Sessions")
        .dimension(coachingSessionDimension)
        .barPadding(0.1)
        .outerPadding(0.05)
        .group(coachingSessionGrouping)
        .on("postRender", function (c) {
          that.adjustBarChartLabels(c);
        });
    },
    renderRateChart(cf) {
      const that = this;
      this.rateChart = dc.pieChart("#rate-chart");
      var rateDimension = cf.dimension(function (d) {
        var ret = d.rateCoaching === null ? "null" : d.rateCoaching;
        return ret;
      });
      var rateGrouping = rateDimension.group();
      that.rateChart
        .width(150)
        .height(150)
        .dimension(rateDimension)
        .group(rateGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderBenefittedChart(cf) {
      const that = this;
      this.benefittedChart = dc.pieChart("#benefitted-chart");
      var benefittedDimension = cf.dimension(function (d) {
        var ret = d.benefitted === null ? "null" : d.benefitted;
        return ret;
      });
      var benefittedGrouping = benefittedDimension.group();
      that.benefittedChart
        .width(150)
        .height(150)
        .dimension(benefittedDimension)
        .group(benefittedGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderConnectedChart(cf) {
      const that = this;
      this.connectedChart = dc.pieChart("#connected-chart");
      var connectedDimension = cf.dimension(function (d) {
        var ret = d.connected === null ? "null" : d.connected;
        return ret;
      });
      var connectedGrouping = connectedDimension.group();
      that.connectedChart
        .width(150)
        .height(150)
        .dimension(connectedDimension)
        .group(connectedGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderActionsChart(cf) {
      const that = this;
      this.actionsChart = dc.pieChart("#actions-chart");
      var actionsDimension = cf.dimension(function (d) {
        var ret = d.actions === null ? "null" : d.actions;
        return ret;
      });
      var actionsGrouping = actionsDimension.group();
      this.actionsChart
        .width(150)
        .height(150)
        .dimension(actionsDimension)
        .group(actionsGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderExpectionsChart(cf) {
      const that = this;
      this.expectationsChart = dc.pieChart("#expectations-chart");
      var expectationsDimension = cf.dimension(function (d) {
        var ret = d.expectations === null ? "null" : d.expectations;
        return ret;
      });
      var expectationsGrouping = expectationsDimension.group();
      this.expectationsChart
        .width(150)
        .height(150)
        .dimension(expectationsDimension)
        .group(expectationsGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderRecommendChart(cf) {
      const that = this;
      this.recommendChart = dc.pieChart("#recommend-chart");
      var recommendDimension = cf.dimension(function (d) {
        var ret = d.recommend === null ? "null" : d.recommend;
        return ret;
      });
      var recommendGrouping = recommendDimension.group();
      this.recommendChart
        .width(150)
        .height(150)
        .dimension(recommendDimension)
        .group(recommendGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderFeedbackTable(cf) {
      this.feedbackTable = dc.dataTable("#feedback-table");
      var feedbackDimension = cf.dimension(function (d) {
        return d.feedback;
      });

      this.feedbackTable
        .dimension(feedbackDimension)
        .columns(["feedback", "improve", "takeway", "participants"])
        .size(100)
        .sortBy(function (d) {
          return d.feedback;
        })
        .order(d3.ascending)
        .on("pretransition", function (table) {
          var body = table.selectAll("tbody");
          body.selectAll("tr").style("display", function (d) {
            if (
              d.feedback === null ||
              d.improve === null ||
              d.takeway === null
            ) {
              // if (!d.feedback || !d.usefulPrinciplesTechniques || !d.takeway) {
              return "none";
            }
          });
        });
    },
    resetFilters() {
      this.companyChart.filterAll();
      this.coachingChart.filterAll();
      this.coachingSessionChart.filterAll();
      this.rateChart.filterAll();
      this.connectedChart.filterAll();
      this.actionsChart.filterAll();
      this.recommendChart.filterAll();
      this.expectationsChart.filterAll();
      this.feedbackTable.filterAll();
      dc.redrawAll();
    },
    adjustBarChartLabels(chart) {
      chart
        .svg()
        .selectAll(".axis.x text")
        .on("click", function (d) {
          chart.filter(d);
          dc.redrawAll();
          scrollTo(d);
        })
        .style("text-anchor", "end")
        .attr("dx", function (d) {
          return "-0.6em";
        })
        .attr("transform", function (d) {
          return "rotate(-90, -4, 9) ";
        });
    },
    async getCoaching() {
      const surveyCoaching = new SurveyCoaching(null);
      await surveyCoaching.getGraphData();
      this.uniqueCoachingNames = await surveyCoaching.getUniqueCoachingNames(this.companies);
      this.uniqueCoachingNames.unshift("All");
    }
  },
  computed: {
    async isAdminRole() {
      const user = await Auth.currentAuthenticatedUser();
      const awsGroups =
        user.signInUserSession.accessToken.payload["cognito:groups"];
      if (awsGroups) {
        const roles =
          user.signInUserSession.accessToken.payload["cognito:groups"];
        return roles.includes("ADMIN");
      }
    },
  },
};
</script>
<style>
.dc-table-section {
  display: none !important;
}
.v-btn--open-dialog {
  top: 90px;
  position: fixed;
  margin: 0 0 16px 16px;
}
</style>